
export const series = {
  blue: '#2D78DB',
  aqua: '#1BAF7A',
} as const;

export const status = {
  good: '#0CA30C',
  warning: '#FAB219',
  serious: '#EC835A',
  critical: '#D03B3B',
} as const;


export const taskStatusColors: Record<string, string> = {
  FINISHED: '#0CA30C',
  IN_PROGRESS: '#2D78DB',
  PLANNED: '#6DA7EC',
  DELAYED: '#D03B3B',
  BACKLOG: '#B0B0B4',
  CANCELLED: '#898989',
};

export const criticalityColors: Record<string, string> = {
  EASY: '#0CA30C',
  MIDDLE: '#FAB219',
  HIGH: '#D03B3B',
};

export const chrome = {
  textPrimary: '#2E2E32',
  textSecondary: '#898989',
  muted: '#B0B0B4',
  grid: '#EBEDF0',
  axis: '#D9DBDF',
  surface: '#FFFFFF',
} as const;

export const delta = {
  good: '#0CA30C',
  bad: '#D03B3B',
} as const;

export const chartFont = "'Onest', system-ui, -apple-system, 'Segoe UI', sans-serif";
